import type { AllowedDomainsInTag } from './types';

/**
 * This config will be used in case if there is on `config.ALLOWED_DOMAINS_IN_ELEMENT` passed to the NextgenDOMPurify
 */
export const FALLBACK_DOMAIN_CONFIG: AllowedDomainsInTag[] = [
  {
    tagName: 'a',
    urlAttribute: 'href',
    allowedDomains: [],
    allowOnlySecureUrls: true,
  },
  {
    tagName: 'img',
    urlAttribute: 'src',
    allowedDomains: [],
    allowOnlySecureUrls: true,
  },
];
